// extracted by mini-css-extract-plugin
export var compactFilters = "_cf-4";
export var detailImage = "_cf-1";
export var dropdownContainer = "_cf-2";
export var imageContainer = "_cf-0";
export var selectedCard = "_cf-3";